import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  Link,
  Outlet,
} from '@tanstack/react-router';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: Outlet,
    notFoundComponent: () => (
      <main className="mx-auto flex min-h-dvh max-w-(--prose-max-width) flex-col justify-center gap-3 p-(--page-padding)">
        <h1 className="text-xl">Page not found</h1>
        <p className="text-muted-foreground">
          There is no page at this address. It may have moved.
        </p>
        <p>
          <Link
            to="/"
            className="font-medium text-foreground underline underline-offset-4"
          >
            Go to Home
          </Link>
        </p>
      </main>
    ),
  },
);
